import { Auth } from 'aws-amplify';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useHistory } from 'react-router-dom';
import 'semantic-ui-less/semantic.less';
import { Grid } from 'semantic-ui-react';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { IRecipientModelSnapshotIn, Recipient } from '../../Models/Recipient';
import RecipientForm from './RecipientForm';

export const Questionaire: React.FC = () => {
  const { caregiverStore } = useAgeReadyContext();
  const history = useHistory();

  const onCancelClick = () => {
    history.push('/home');
  };

  const onSaveHandler = async (savedRecipient: IRecipientModelSnapshotIn) => {
    const userInfo = await Auth.currentAuthenticatedUser();
    await caregiverStore.saveRecipient(userInfo.attributes.sub, savedRecipient);
  };

  return (
    <>
      <Grid stackable style={{ margin: '0 auto 0 auto' }}>
        <div style={{ padding: 0, marginTop: 20}}>
          {/* <Divider hidden /> */}
         <Grid.Row>
             <RecipientForm
              data-testid='newRecipientForm'
              isLoading={false}
              cancelButtonLabel='Cancel'
              formType="Add"
              selectedRecipient={Recipient.create()}
              onSaveClick={async ( savedRecipient: IRecipientModelSnapshotIn ) => {
                await onSaveHandler(savedRecipient);
              }}
              onCancelClick={onCancelClick}
            />
          </Grid.Row>
        </div>
      </Grid>
    </>
  );
};

export default observer(Questionaire);
